import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

export type CountryOption = {
  code: string;
  name: string;
};

/**
 * Manual labels where ISO official/alias names are still too long for narrow selects.
 * ISO codes stored in form state are unchanged.
 */
const COUNTRY_DISPLAY_OVERRIDES: Partial<Record<string, string>> = {
  BQ: 'Caribbean Netherlands',
  FM: 'Micronesia',
  GS: 'South Georgia & Sandwich Is.',
  HM: 'Heard & McDonald Islands',
  LA: 'Laos',
  UM: 'US Outlying Islands',
  VC: 'St. Vincent & Grenadines',
};

function getCountryDisplayName(
  code: string,
  officialName: string,
  aliasName?: string,
): string {
  const override = COUNTRY_DISPLAY_OVERRIDES[code];
  if (override) return override;

  return aliasName && aliasName.length < officialName.length ? aliasName : officialName;
}

/** ISO 3166-1 alpha-2 codes with English display names, sorted A–Z. */
export function getCountryOptions(): CountryOption[] {
  const officialNames = countries.getNames('en', { select: 'official' });
  const aliasNames = countries.getNames('en', { select: 'alias' });

  return Object.entries(officialNames)
    .map(([code, officialName]) => ({
      code,
      name: getCountryDisplayName(code, officialName, aliasNames[code]),
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function isValidCountryCode(code: string): boolean {
  return countries.isValid(code);
}

/** Default billing country for checkout (ISO alpha-2). */
export const DEFAULT_BILLING_COUNTRY = 'US';
